import axios from 'axios';

import { handleInterceptorErrors } from 'common/utils/helpers/api';

const API = axios.create({
    baseURL: 'https://api.bitbucket.org/2.0',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        common: {
            Authorization: `Basic ${btoa('alejandrosansor:ATBBpyf8RJX5VdamSDJeUVX45RbW43188247')}`,
        },
    },
});

API.interceptors.response.use(
    (res) => res,
    (error) => handleInterceptorErrors({}, error, false),
);

export default API;
